

import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CurrencyFormat from "react-currency-format";

import GeneralModal from "../../src/helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { SetPlanEdit } from "../store/productAtom";
import LogicContext from "../Context/LogicContext";
import { productService } from "../services/product.service";
import { formatCustomNumber } from "../helpers/formatCustomNumber";

function ProductPlans({ Product_Id }) {
  const [plansList, setPlansList] = useState([]);
  const [bankUpPlanList, setBackUpPlanList] = useState([]);
  const showModal = createModal(GeneralModal);
  const setPlanEdit = SetPlanEdit();
  const logicContext = useContext(LogicContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [moduleId, moduleName, userMenu] = pathname.split("/").slice(1, 4);
    const { showToast, httpResponseManager } = useContext(LogicContext);
  



  useEffect(() => {
    if (Product_Id) {
      fetchPlans();
    }
  }, [Product_Id]);

  const fetchPlans = async () => {
    const res = await productService.getProductByPlan(Product_Id);
    const data = res.data?.Product || [];
    setPlansList(data);
    setBackUpPlanList(data);
  };

  const handleEdit = async (plan) => {
    const res = await showModal({
      title: "Edit Plan?",
      body: "Do you want to modify this record?",
      showInput: false,
    });

    if (res?.decision) {
      setPlanEdit(plan);
      navigate(
        `/${moduleId}/${moduleName}/${userMenu}/add-plan/${plan.Product_Id}`
      );
    }
  };

  const handleStatusChange = async (plan, actionType) => {
    const modal = await showModal({
      title:
        actionType === "activate" ? "Mark as Active!" : "Mark as Inactive!",
      body: `Do you want to mark this Plan as ${
        actionType === "activate" ? "Active" : "Inactive"
      }?`,
      showInput: false,
    });

    if (!modal?.decision) return;

    const option = actionType === "activate" ? 5 : 4;
    const res = await productService.updateProductStatus({
      product_id: plan.Product_Id,
      plan_id: plan.Plan_Id,
      option,
    });
    const response = httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
    if (response.message_id === 1) {
      showToast(response.message_text || 'Successful!', 'success');
      setPlansList((prev) =>
        prev.map((p) =>
          p.Plan_Id === plan.Plan_Id
            ? {
                ...p,
                Plan_Status_Name: "Active",
                Plan_Status_Id: actionType === "activate" ? 1 : 2,
              }
            : p
        )
      );
     
    } else {
      showToast(response.message_text || 'Failed to save', 'error');
    }
    
    

    
  
  };

  const handleSearch = (query) => {
    if (query?.length < 3) {
      return setPlansList(bankUpPlanList);
    }
    const filteredList = bankUpPlanList.filter(
      (item) =>
        [
          item.Product_Name,
          item.Plan_Name,
          item.Item_Sku,
          item.Plan_Features,
        ].some((field) => field?.toLowerCase().includes(query.toLowerCase())) ||
        item.Plan_Price?.toString().includes(query)
    );
    console.log("filtered ", filteredList);
    setPlansList(filteredList);
  };

  return (
    <section className="my-4 max-w-5xl mx-auto">
  <div className="bg-white rounded-2xl shadow-lg p-6">
    {/* Header with Search */}
    <div className="flex items-center justify-between mb-6">
      <h2 className="text-xl font-semibold text-gray-800">Plans</h2>
      <div className="flex items-center gap-4">
        <input
          onChange={(e) => handleSearch(e.target.value)}
          className="w-64 px-4 py-2 text-sm border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          placeholder="Search product"
        />
      </div>
    </div>

    {/* Plans List */}
    <div className="space-y-6">
      {plansList?.length === 0 && (
        <p className="text-center text-gray-500 text-sm py-4">
          No plans found.
        </p>
      )}
      {plansList.map((plan, i) => (
        <div
          key={i}
          className="flex flex-col md:flex-row border border-gray-200 rounded-xl p-6 gap-6 bg-white hover:shadow-md transition-shadow"
        >
          <div className="flex-shrink-0 w-full md:w-40 rounded-lg overflow-hidden">
            <img
              src={plan.image_URL}
              alt="Plan"
              className="w-full h-24 object-cover"
            />
          </div>
          <div className="flex-grow space-y-3">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-lg font-bold text-gray-800">{plan.Plan_Name}</p>
                <p className="text-sm text-gray-500">Plan Code: {plan.Plan_Id}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">
                  Status:{" "}
                  <span
                    className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                      plan.Plan_Status_Id === 1
                        ? "bg-green-100 text-green-700"
                        : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {plan.Plan_Status_Name}
                  </span>
                </p>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              <span className="font-semibold">Associated Addons:</span>{" "}
              {plan.Plan_Features}
            </p>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <span className="text-xl font-bold text-gray-700">
                <CurrencyFormat
                  value={formatCustomNumber(plan.Plan_Price)}
                  displayType={"text"}
                  thousandSeparator
                  prefix="₦"
                />
                <span className="ml-2 text-sm text-gray-600">
                  {plan.Bill_Duration_Type_Name}
                </span>
              </span>
              <div className="flex gap-3 mt-3 sm:mt-0">
                <button
                  className="px-4 py-2 text-sm font-medium rounded-lg bg-yellow-400 text-white hover:bg-yellow-500 transition-colors"
                  onClick={() => handleEdit(plan)}
                >
                  Edit
                </button>
                {plan.Plan_Status_Id === 1 && (
                  <button
                    className="px-4 py-2 text-sm font-medium rounded-lg bg-orange-400 text-white hover:bg-orange-500 transition-colors"
                    onClick={() => handleStatusChange(plan, "inactivate")}
                  >
                    Mark as Inactive
                  </button>
                )}
                {plan.Plan_Status_Id === 2 && (
                  <button
                    className="px-4 py-2 text-sm font-medium rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors"
                    onClick={() => handleStatusChange(plan, "activate")}
                  >
                    Mark as Active
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
  );
}

export default ProductPlans;
